import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const QrCodeSkeleton = () => {
	return <Skeleton className="h-[300px] w-[300px] rounded-md" />;
};
